import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import { JourneyRepository } from '../../../data/repositories/journey-repository'
import type { Journey, JourneyVerifyRequest } from '../../../domain/models/journey'
import { JourneyService } from '../../../service/journey-service'
import { JourneyController } from '../../controllers/journey-controller'
import * as action from '../actions/journey-actions'
import { setDailyTotal } from '../../../../../store/daily-sales/daily-sales.slice'
import { isJourneyActive } from '../../../../../utils/journey-utils'

export const getJourneyController = async (payload: JourneyVerifyRequest) => {
  const { key, token } = await makeAccess()
  const dataSource = new JourneyService(apiConfig(key, token))
  const repository = new JourneyRepository(dataSource)
  const control = new JourneyController(repository)
  const result = await control.getJourney(payload)
  
  return result
}

export function* getJourneySaga({ payload }: any): any {
  try {
    const result: Journey | null = yield call(getJourneyController, payload)
    
    // Se a jornada existe mas está finalizada (status 1), tratar como "sem jornada ativa"
    if (result && !isJourneyActive(result)) {
      yield put(action.getJourneySuccess(null))
      return
    }
    
    yield put(action.getJourneySuccess(result))
    
    // Atualiza o total de vendas do dia se há uma jornada ativa
    if (result && result.totalAmount !== undefined) {
      yield put(setDailyTotal(result.totalAmount))
    }
  } catch (error: any) {
    yield put(action.getJourneyError(error.toString()))
  }
}